import React from 'react';
import { Page } from '../Common/Components/Page';
import { EventRuleManagementContent } from './Components/EventRuleManagementContent';
import { EventTriggerProvider } from './Providers/EventTriggerProvider';

export const EventRuleManagement = (): React.JSX.Element => (
  <Page title="Event Rules" accessKey={'eventRules'} isSearchable={true}>
    <EventTriggerProvider>
      <EventRuleManagementContent />
    </EventTriggerProvider>
  </Page>
);
